<template>
    <div class="forgetPS">
        <h2 class="forgetPSText">找回密码</h2>
        <div class="form">
            <div class="formItem">
                <p class="tag">账号</p>
                <input class="input" type="text" v-model="username" placeholder="请输入找回帐号"/>
            </div>
            <div class="formItem">
                <p class="tag">绑定手机</p>
                <input class="input" type="text" v-model="mobile" placeholder="请输入绑定手机"/>
            </div>
            <div class="formItem">
                <p class="tag">手机验证码</p>
                <input class="input" v-model="code" maxlength="6" type="text" placeholder="请输入验证码"/>
                <div class="getCodeBtn" @click="getCodeFn">
                    <span>{{codeText}}</span>
                </div>
            </div>
        </div>
        <div class="btn" @click="onSave">
            <span>提交</span>
        </div>
    </div>
</template>

<script>
    /*
    * 忘记密码
    * */
    import {getRestPasswordSMS, getAuthTicket} from '../../../api/login'
    export default {
        name: "forgetPS",
        data() {
            return {
                codeText: '获取验证码',
                username: '',
                mobile: '',
                password: '',
                code: '',
                phoneReg: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                num: 60
            }
        },
        methods: {
            onSave() {
                if(!this.mobile) return this.toast({text: '请输入手机号码', icon: 'warning'});
                if (!this.username) return this.toast({text: '请输入帐号', icon: 'warning'});
                if(!this.phoneReg.test(this.mobile)) return this.toast({text: '手机号码格式错误', icon: 'warning'});
                if(!this.code) return this.toast({text: '请输入验证码', icon: 'warning'});
                getAuthTicket(this.username, this.mobile, this.code).then(res => {
                    this.toPage(`/setNewPS?ticket=${res}`, true);
                })
            },
            getCodeFn() {
                if(this.num !== 60) return this.toast({text: `${this.num}秒后可再次获取`, icon: 'warning'});
                if(!this.mobile) return this.toast({text: '请输入手机号码', icon: 'warning'});
                if (!this.username) return this.toast({text: '请输入帐号', icon: 'warning'});
                if(!this.phoneReg.test(this.mobile)) return this.toast({text: '手机号码格式错误', icon: 'warning'});
                getRestPasswordSMS(this.username, this.mobile).then(res => {
                    var timer = '';
                    timer = setInterval(() => {
                        if(this.num === 0) {
                            clearInterval(timer);
                            this.codeText = '获取验证码';
                            this.num = 60;
                        } else {
                            this.codeText = this.num + ' S';
                            this.num--;
                        }
                    }, 1000);
                })
            },
        }
    }
</script>

<style scoped>
    .forgetPS {
        padding: 0 7vw;
        min-height: 100vh;
        background-color: white;
    }

    .forgetPSText {
        font-size: 5vw;
        color: #1b1b4e;
        line-height: 20vw;
    }

    .tag {
        margin-bottom: 2vw;
        font-size: 3vw;
        color: #3b4664;
    }

    .formItem {
        position: relative;
        margin-bottom: 5vw;
        border-bottom: 1px solid #ededed;
    }

    .input {
        display: block;
        width: 100%;
        border: none;
        height: 10vw;
        padding: 2vw 0;
        line-height: 10vw;
        font-size: 4vw;
        box-sizing: border-box;
        outline: none;
    }

    .input::placeholder {
        color: #AEB3C0;
    }

    .getCodeBtn {
        position: absolute;
        top: 53%;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 18vw;
        height: 5vw;
        border: solid 1px #49a7f4;
        font-size: 3vw;
        color: #49a7f4;
    }

    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 85vw;
        height: 11vw;
        margin-top: 13vw;
        font-size: 5vw;
        color: #ffffff;
        background-image: linear-gradient(90deg,
        #31a2fe 0%,
        #4ca8f3 100%),
        linear-gradient(
            #ff6a49,
            #ff6a49);
        background-blend-mode: normal,
        normal;
        box-shadow: 0vw 1vw 3vw 0vw
        rgba(49, 162, 254, 0.39);
        border-radius: 5vw;
    }
</style>



// WEBPACK FOOTER //
// src/page/login/forgetPS/ForgetPS.vue